import './DailyRemblePlaylist.scss'

import { useEffect, useState } from 'react'
import { useParams, NavLink, useHistory } from 'react-router-dom'
import Drawer from 'react-bottom-drawer'
import parse from 'html-react-parser'
import { useMediaQuery } from 'react-responsive'

import { toggleTabBar } from 'components/common/helpers/Mobile'
import { ROUTE_TODAY } from '../../common/helpers/Paths'
import Loading from '../../../templates/Loading'
import DailyRembleVideo from '../DailyRembleVideo/DailyRembleVideo'
import { getLMSObjectById } from 'components/common/api'

/**
 * Daily Remble Playlist component. This component is used to display the daily remble playlist.
 * @param {Object} params Initial props:
 * `setReturnPath` - Function to set the return path
 * `setHeaderTitle` - Function to set the header title
 * `cache` - Global cache
 * @returns
 */

export default function DailyRemblePlaylist({
  setReturnPath,
  setHeaderTitle,
  cache
}) {
  const history = useHistory()
  const isSmallScreen = useMediaQuery({ maxWidth: 767 })

  const { dailyRembleId } = useParams()
  const [video, setVideo] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [authorBio, setAuthorBio] = useState()
  const [showAuthorBio, setShowAuthorBio] = useState()

  // Do we have a returnPath to use from the query string?
  const returnPath =
    new URLSearchParams(history.location.search).get('returnPath') ||
    ROUTE_TODAY

  /**
   * Main effect to get the daily remble videos
   */
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Return early if no daily remble id
    if (!dailyRembleId) return

    // Set header title and return path
    setReturnPath(returnPath)
    setHeaderTitle(null)

    // Add no touch body class, to prevent the user from swiping on the body
    document.body.classList.add('no-touch-action')

    // Hide tab bar on mobile
    toggleTabBar('off')

    // Get Daily Remble Videos
    async function getDailyRembleVideoAsync() {
      // Return early if no daily remble id
      if (!dailyRembleId) return
      const result = await getLMSObjectById(dailyRembleId)

      setVideo(result)
      setIsLoading(false)
    }

    getDailyRembleVideoAsync()
  }, [dailyRembleId, returnPath, cache, setReturnPath, setHeaderTitle])

  return (
    <Loading isLoaded={isLoading}>
      <div className='daily-remble-full-screen-wrapper'>
        <NavLink
          to={ROUTE_TODAY}
          className='back-button position-absolute text-decoration-none text-white fs-3 p-4 align-center'
        >
          <i className='bi bi-arrow-left' />
          {!isSmallScreen && <span>&nbsp;Back</span>}
        </NavLink>
        <DailyRembleVideo
          video={video}
          setAuthorBio={setAuthorBio}
          setShowAuthorBio={setShowAuthorBio}
        />
        <Drawer
          duration={250}
          hideScrollbars={true}
          onClose={() => setShowAuthorBio(false)}
          isVisible={showAuthorBio}
          className='daily-remble-author-drawer'
        >
          {authorBio && (
            <div className='daily-remble-author-details'>
              <h2>About the author</h2>
              <h3 className='author-name mb-3'>{parse(authorBio.name)}</h3>
              <div className='author-bio'>{parse(authorBio.bio)}</div>
            </div>
          )}
        </Drawer>
      </div>
    </Loading>
  )
}
